import { isOptionsGroup, type ComboboxParsedItem, type OptionsFilter } from '@mantine/core';
import { matchesAllTokens, searchTokens } from '@/shared/components/RemoteSelect/remoteSearch';

/** Il filtro di Mantine cerca la frase intera: qui ogni parola, in qualunque ordine. */
export const tokenOptionsFilter: OptionsFilter = ({ options, search, limit }) => {
  const tokens = searchTokens(search);
  if (tokens.length === 0) return options;
  const out: ComboboxParsedItem[] = [];
  for (const o of options) {
    if (out.length >= limit) break;
    if (isOptionsGroup(o)) {
      const items = o.items.filter((i) => matchesAllTokens(i.label, tokens)).slice(0, limit - out.length);
      if (items.length > 0) out.push({ group: o.group, items });
    } else if (matchesAllTokens(o.label, tokens)) {
      out.push(o);
    }
  }
  return out;
};
